import { SEARCH_TYPE_NAMES } from '@lt/components/constants/search';

import type {
  WidgetSettingsConstructorParams,
  SelectOption,
} from '../../context/constructorContext/types';
import { DepartureOptions } from '@lt/api/dist/types/departure';
import { WidgetName } from '../../models';

export const mapOptionToArray = <V>(options: Record<string, V>): SelectOption<V>[] => {
  return Object.entries(options).map(([label, value]) => ({
    label,
    value,
  }));
};

export const configureDepartures = (
  config: Partial<WidgetSettingsConstructorParams>,
  departures: DepartureOptions
): WidgetSettingsConstructorParams['departure'] => {
  if (config.selectedWidget?.value === WidgetName.PACKAGE) {
    return;
  }

  if (config.search_type?.value === SEARCH_TYPE_NAMES.HOTEL) {
    return { active: true };
  }

  if (config.departure?.options) {
    return config.departure;
  }

  return {
    label: 'Город вылета',
    description: 'Выберите город вылета',
    active: true,
    options: departures?.reduce((result, departure) => {
      result[departure.label] = departure;

      return result;
    }, {}),
    value: departures?.find((departure) => departure.id === 213),
  };
};
